export const getNormalizedBrowserLanguage = () => {
  switch (window.navigator.language) {
    case 'fi': return 'fi-FI'
    case 'sv': return 'sv-SE'
    case 'nl': return 'nl-NL'
    default:
      return window.navigator.language
  }
}
